import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZapFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.3982 1.08275C13.8054 1.25952 14.0473 1.68359 13.9923 2.12409L13.1328 9.00006L19.3277 9.00005C19.5687 9.00001 19.8128 8.99996 20.0123 9.01802C20.2009 9.03509 20.562 9.08027 20.8753 9.33338C21.2338 9.62314 21.4392 10.0617 21.4323 10.5227C21.4262 10.9253 21.2297 11.2317 21.1221 11.3875C21.0083 11.5523 20.852 11.7398 20.6977 11.9249L11.7682 22.6402C11.484 22.9813 11.009 23.0941 10.6018 22.9174C10.1946 22.7406 9.95264 22.3165 10.0077 21.876L10.8672 15.0001L4.67221 15.0001C4.43122 15.0001 4.18713 15.0002 3.9877 14.9821C3.79909 14.965 3.43793 14.9198 3.12471 14.6667C2.76614 14.377 2.56072 13.9384 2.56768 13.4774C2.57375 13.0748 2.77026 12.7684 2.87788 12.6126C2.99168 12.4478 3.14798 12.2603 3.3023 12.0752C3.30995 12.066 3.31759 12.0569 3.32522 12.0477L12.2318 1.35987C12.516 1.01884 12.991 0.905986 13.3982 1.08275Z",
		fill: "currentColor"
	})
});
export default SvgZapFilled;
